import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, FormField, TextArea } from 'ui';

const TextInputMode = ({ error, value, onChange, placeholder, wordCount, wordLimit, onOpenDialog, disabled, name }) => {
  const { t } = useTranslation(['chatbot']);
  const handleChange = (e) => {
    onChange(e.currentTarget.value);
  };

  return (
    <div className={`text-input-mode ${error ? 'text-input-mode--error' : ''}`}>
      <div className="text-input-mode__textarea-wrapper">
        <FormField isDisabled={disabled} isLabelHidden label={placeholder}>
          <TextArea name={name} placeholder={placeholder} onChange={handleChange} value={value} rows={2} />
        </FormField>
      </div>

      <div className="text-input-mode__footer">
        <div>
          <Button
            text={t('chatbot:Choose from book')}
            size="lg"
            variant="primary-ghost"
            onClick={onOpenDialog}
            isDisabled={disabled}
            className="text-input-mode__choose-button"
          />
        </div>

        <div className="text-input-mode__counter">
          {t('chatbot:Word limit')}: {wordCount}/{wordLimit}
        </div>
      </div>
    </div>
  );
};

TextInputMode.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  wordCount: PropTypes.number.isRequired,
  wordLimit: PropTypes.number.isRequired,
};

TextInputMode.defaultProps = {
  disabled: false,
  error: false,
  name: 'text-input',
  placeholder: '',
  wordLimit: 2000,
};

export default TextInputMode;
